// src/components/GoogleLoginButton.js
import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
// import jwt_decode from 'jwt-decode'; // No es estrictamente necesario aquí

// Añadimos 'onErrorCallback' para comunicar errores al modal padre
function GoogleLoginButton({ onSuccess, onErrorCallback }) {

  const handleSuccess = async (credentialResponse) => {
    try {
      const googleToken = credentialResponse.credential;
      // const decoded = jwt_decode(googleToken); // Podemos quitar esto
      // console.log("Google Decoded:", decoded);

      // Llama a tu backend para hacer login/registro con este token
      // Usar ruta relativa para el proxy
      const res = await fetch('/api/google-login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: googleToken }), // El backend espera 'token'
      });

      const data = await res.json();

      if (res.ok && data.access_token) {
        // Éxito: Guardar el token de *nuestra* app y llamar al onSuccess general
        localStorage.setItem('access_token', data.access_token); // <<<--- CLAVE CORREGIDA
        if (onSuccess) onSuccess(data.access_token); // <<<--- Pasar solo el token
      } else {
        // Error del backend: llamar al callback de error del modal
        console.error("Backend Google Login Error:", data);
        if (onErrorCallback) onErrorCallback(data.error || 'Error al procesar inicio de sesión con Google.');
      }
    } catch (err) {
      // Error de red u otro error inesperado
      console.error('Error during Google login API call:', err);
      if (onErrorCallback) onErrorCallback('Error de conexión al iniciar sesión con Google.');
    }
  };

  const handleError = () => {
    console.error('Google Login Failed');
    // Informar al usuario a través del modal si es necesario
    if (onErrorCallback) onErrorCallback('Falló el inicio de sesión con Google.');
  };

  return (
    <div className="w-full flex justify-center"> {/* Contenedor para centrar/estilar */}
       <GoogleLogin
         onSuccess={handleSuccess}
         onError={handleError}
         // theme="outline" // Puedes personalizar tema, tamaño, etc.
         // size="large"
         // width="300px" // Ajusta el ancho si es necesario
         useOneTap // Mantenemos one-tap si quieres
       />
    </div>
  );
}

export default GoogleLoginButton;